import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vModelDynamic as _vModelDynamic, mergeProps as _mergeProps, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row mx-4" }
const _hoisted_2 = { class: "col-sm-9" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-sm-3" }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_7 = {
  key: 0,
  class: "is-invalid"
}
const _hoisted_8 = { class: "col-sm-3" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_11 = {
  key: 0,
  class: "is-invalid"
}
const _hoisted_12 = { class: "col-sm-3" }
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_15 = {
  key: 0,
  class: "is-invalid"
}
const _hoisted_16 = { class: "col-sm-3" }
const _hoisted_17 = { class: "form-group" }
const _hoisted_18 = ["disabled"]
const _hoisted_19 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_20 = { class: "row min-vh-75" }
const _hoisted_21 = { class: "col-sm-3 pe-4" }
const _hoisted_22 = { class: "form-group" }
const _hoisted_23 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_24 = {
  key: 0,
  class: "is-invalid"
}
const _hoisted_25 = { class: "list-group places-group-up text-xs" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "row" }
const _hoisted_28 = { class: "col-10" }
const _hoisted_29 = { class: "col-2 text-end" }
const _hoisted_30 = {
  key: 0,
  class: "spinner-border spinner-border-sm text-secondary",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_31 = ["onClick"]

import { Ref, ref, watch, onMounted } from 'vue'
import { Field, Form, FormActions } from 'vee-validate'
import * as yup from 'yup'
import PlacesRepository from '@/repositories/PlaceRepository'
import { PlaceInterface } from '@/types/PlaceInterface'
import ToastService from '@/services/ToastService'
import Place from '@/models/Place'
import i18n from '@/plugins/i18n'
import { usePlacesStore } from '@/services/stores/PlacesStore'
import Map from '@/components/maps/Map.vue'
import { storeToRefs } from 'pinia'
import { google } from 'google-maps'
import { StrHelper } from '@/helpers/StrHelper'
import { useSettingsStore } from '@/services/stores/SettingsStore'


export default /*@__PURE__*/_defineComponent({
  __name: 'Places',
  setup(__props) {

const place: Ref<Place> = ref(new Place())
const searchPlace: Ref<string> = ref('')
const foundPlaces: Ref<Array<Place>> = ref([])
const placesStore = usePlacesStore()
const { results, isReady, currentCityId } = storeToRefs(placesStore)
const settingsStore = useSettingsStore()
const { branchSelected } = storeToRefs(settingsStore)
const selectedPlace: Ref<Array<Place>> = ref([])
const creating = ref(false)
const deletingKeys: Ref<Set<string>> = ref(new Set())

function placeKey(placeItem: Place): string {
  return placeItem.id || placeItem.key
}

function isDeleting(placeItem: Place): boolean {
  return deletingKeys.value.has(placeKey(placeItem))
}

onMounted(() => {
  if (!branchSelected.value?.city) {
    ToastService.toast(ToastService.ERROR, i18n.global.t('settings.messages.select_city'))
    return
  }
  hydratePlaces(searchPlace.value).catch(() => undefined)
})

watch(searchPlace, (placeName) => {
  hydratePlaces(placeName).catch(() => undefined)
})

watch(results, (newPlaces) => {
  foundPlaces.value = newPlaces
})

watch([isReady, currentCityId], async ([ready]) => {
  if (!ready) {
    return
  }
  await hydratePlaces(searchPlace.value)
})

const schema = yup.object().shape({
  name: yup.string().required().min(3),
  lat: yup.number().required(),
  lng: yup.number().required(),
})

function createPlace(_values: PlaceInterface, event: FormActions<any>): void {
  creating.value = true
  if (!branchSelected.value?.city) {
    creating.value = false
    ToastService.toast(ToastService.ERROR, i18n.global.t('settings.messages.select_city'))
    return
  }
  place.value.name = StrHelper.toCamelCase(place.value.name)
  PlacesRepository.create(place.value, branchSelected.value.city.id).then(() => {
    event.resetForm()
    ToastService.toast(ToastService.SUCCESS, i18n.global.t('common.messages.created'))
    placesStore.hydratePlacesInBackground(branchSelected.value?.city?.id).then(() => hydratePlaces(searchPlace.value)).finally(() => {
      creating.value = false
    })
  }).catch((e) => {
    creating.value = false
    ToastService.toast(ToastService.ERROR, i18n.global.t('common.messages.error'), e.message)
  })
}

function selectPlace(placeSelected: Place): void {
  selectedPlace.value = [placeSelected]
}

function onMapClick(latLng: google.maps.LatLng): void {
  place.value = new Place()
  place.value.lat = latLng.lat()
  place.value.lng = latLng.lng()
}

async function deletePlace(deletedPlace: Place): Promise<void> {
  const deletedPlaceId = placeKey(deletedPlace)
  deletingKeys.value.add(deletedPlaceId)
  deletedPlace.delete().then(() => {
    deletingKeys.value.delete(deletedPlaceId)
    searchPlace.value = ''
    foundPlaces.value = foundPlaces.value.filter((placeItem) => placeKey(placeItem) !== deletedPlaceId)
    placesStore.remove(deletedPlace)
    ToastService.toast(ToastService.SUCCESS, i18n.global.t('common.messages.deleted'))
  }).catch((e) => {
    deletingKeys.value.delete(deletedPlaceId)
    ToastService.toast(ToastService.ERROR, i18n.global.t('common.messages.error'), e.message)
  })
}

async function hydratePlaces(term: string): Promise<void> {
  const placesResult = await placesStore.searchPlaces(term)
  foundPlaces.value = placesResult
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(Form), {
        onSubmit: createPlace,
        "validation-schema": _unref(schema),
        autocomplete: "off"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_unref(Field), {
                  name: "name",
                  type: "text",
                  modelValue: place.value.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((place.value.name) = $event))
                }, {
                  default: _withCtx(({ field, errorMessage, meta }) => [
                    _withDirectives(_createElementVNode("input", _mergeProps({
                      class: "form-control",
                      id: "name",
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                      placeholder: _ctx.$t('common.placeholders.name')
                    }, field, { autocomplete: "off" }), null, 16, _hoisted_6), [
                      [_vModelDynamic, field.value]
                    ]),
                    (errorMessage || !meta.dirty)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(errorMessage), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_unref(Field), {
                  name: "lat",
                  type: "text",
                  modelValue: place.value.lat,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((place.value.lat) = $event))
                }, {
                  default: _withCtx(({ field, errorMessage, meta }) => [
                    _withDirectives(_createElementVNode("input", _mergeProps({
                      class: "form-control",
                      id: "lat",
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                      placeholder: _ctx.$t('services.fields.lat')
                    }, field, { autocomplete: "off" }), null, 16, _hoisted_10), [
                      [_vModelDynamic, field.value]
                    ]),
                    (errorMessage || !meta.dirty)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(errorMessage), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_unref(Field), {
                  name: "lng",
                  type: "text",
                  modelValue: place.value.lng,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((place.value.lng) = $event))
                }, {
                  default: _withCtx(({ field, errorMessage, meta }) => [
                    _withDirectives(_createElementVNode("input", _mergeProps({
                      class: "form-control",
                      id: "lng",
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                      placeholder: _ctx.$t('services.fields.lng')
                    }, field, { autocomplete: "off" }), null, 16, _hoisted_14), [
                      [_vModelDynamic, field.value]
                    ]),
                    (errorMessage || !meta.dirty)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(errorMessage), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("button", {
                  type: "submit",
                  class: "btn btn-primary",
                  disabled: creating.value
                }, [
                  (creating.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_19))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('common.actions.create')), 1)
                ], 8, _hoisted_18)
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["validation-schema"]),
      _createElementVNode("div", _hoisted_20, [
        (_unref(branchSelected)?.city)
          ? (_openBlock(), _createBlock(Map, {
              key: 0,
              places: selectedPlace.value,
              onOnMapClick: onMapClick,
              "add-listener": true
            }, null, 8, ["places"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createElementVNode("h5", null, _toDisplayString(_ctx.$t('routes.places')), 1),
      _createElementVNode("div", _hoisted_22, [
        _createVNode(_unref(Field), {
          name: "lat",
          type: "search",
          modelValue: searchPlace.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((searchPlace).value = $event))
        }, {
          default: _withCtx(({ field, errorMessage, meta }) => [
            _withDirectives(_createElementVNode("input", _mergeProps({
              class: "form-control form-control-sm",
              type: "search",
              "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
              placeholder: _ctx.$t('common.placeholders.search')
            }, field, { autocomplete: "off" }), null, 16, _hoisted_23), [
              [_vModelText, field.value]
            ]),
            (errorMessage || !meta.dirty)
              ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(errorMessage), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createElementVNode("ul", _hoisted_25, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(foundPlaces.value, (place, key) => {
          return (_openBlock(), _createElementBlock("li", {
            class: "list-group-item list-group-item-action",
            onClick: ($event: any) => (selectPlace(place)),
            key: key
          }, [
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, _toDisplayString(place.name), 1),
              _createElementVNode("div", _hoisted_29, [
                (isDeleting(place))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_30))
                  : (_openBlock(), _createElementBlock("em", {
                      key: 1,
                      class: "fa-solid fa-trash cursor-pointer",
                      onClick: ($event: any) => (deletePlace(place))
                    }, null, 8, _hoisted_31))
              ])
            ])
          ], 8, _hoisted_26))
        }), 128))
      ])
    ])
  ]))
}
}

})